import { makeStyles } from "@material-ui/core/styles";

export const useStylesNetworkBalance = makeStyles((theme) => ({
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
    maxWidth: "100%",
    position: "relative",
  },
  selectOptions: {
    top: "140px !important",
    width: "45%",
    position: "absolute !important",
    "& .MuiListItem-root": {
      borderRadius: 5,
    },
    "& .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
      backgroundColor: "transparent",
    },
  },
}));

export const useStylesNavBar = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    position: "relative",
    minWidth: 150,
    maxWidth: 250,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    border: "none !important",
    padding: "50px",
    width: "730px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
  paper1: {
    border: "none !important",
    padding: "50px",
    width: "500px",
    position: "relative",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: " 20px 20px 20px 20px !important",
      width: "92% !important",
    },
    "&:focus": {
      outline: "none",
    },
  },
  selectOptions: {
    top: "65px !important",
    width: "100%",
    maxWidth: 150,
    position: "absolute !important",
    "& .MuiListItem-root": {
      borderRadius: 5,
    },
    "& .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
      backgroundColor: "transparent",
    },
  },
}));
